export const depositProgressBarConstant = {
    GET_DEPOSIT_PROGRESS_BAR_DETAILS: 'GET_DEPOSIT_PROGRESS_BAR_DETAILS'
};
